import { inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { Item, SnackbarService } from '@siat-fe/shared';
import { pipe, switchMap } from 'rxjs';
import { RolesService } from './struttura-ruoli-selector.service';

/**
 * State type.
 */
type ListaStruttureState = {
  listaStruttureItemResponse: Item[];
  hasError: boolean;
};

type StruttureItem = {
  id: number;
  nome: string;
};

/**
 * Initial state.
 */
const initialState: ListaStruttureState = {
  listaStruttureItemResponse: [],
  hasError: false,
};

export const ListaStruttureStore = signalStore(
  withState<ListaStruttureState>(initialState),
  withMethods((store, snackbarService = inject(SnackbarService)) => {
    /**
     * Set error.
     */
    const _setError = (hasError: boolean, _message?: string): void => {
      patchState(store, { hasError });
    };
    /**
     * Set success.
     */
    const _setSuccess = (message: string): void => {
      snackbarService.showSuccessSnackbar(message);
    };

    const _setListItem = (
      listaStruttureItemResponse: StruttureItem[]
    ): void => {
      patchState(store, {
        listaStruttureItemResponse: listaStruttureItemResponse.map(
          struttura => ({
            id: struttura.id,
            name: struttura.nome,
          })
        ),
        hasError: false,
      });
    };
    return {
      _setError,
      _setSuccess,
      _setListItem,
    };
  }),
  withMethods((store, strutturaService = inject(RolesService)) => {
    const fetchGetAllStrutture = rxMethod<string>(
      pipe(
        switchMap(_tipologica =>
          strutturaService.fetchGetAllStrutture().pipe(
            tapResponse({
              next: (response: never[]) => store._setListItem(response),
              error: () => store._setError(true),
            })
          )
        )
      )
    );
    return {
      fetchGetAllStrutture,
    };
  }),
  withMethods(store => ({
    /**
     * Reload update list.
     */
    _reloadListItem(typology: string, message: string): void {
      store.fetchGetAllStrutture(typology);
      store._setSuccess(message);
    },
  }))
);
